import { Routes } from '@angular/router';
import { authGuard } from './guards/auth-guard';
import { guestGuard } from './guards/guest-guard';

export const routes: Routes = [
    { path: 'login', loadComponent: () => import('./components/login-component/login-component').then(m => m.LoginComponent), canActivate: [guestGuard] },
    { path: 'home', loadComponent: () => import('./components/home-component/home-component').then(m => m.HomeComponent), canActivate: [authGuard] },
    { path: 'auth/callback/:provider', loadComponent: () => import('./components/callback-component/callback-component').then(m => m.CallbackComponent) },
    { path: '', redirectTo: '/home', pathMatch: 'full' },
];
